<title>Hy Cite - Home</title>
<meta name="description" content="Unlock your potential with HyCite and direct selling our cookware line" />

<ng-container *transloco="let t; read: 'pages.home'">
  <div class="inner-page" id="our-story">
    <div class="content">
      <div class="content-group left">
        <div class="titles">
          <h1 *ngFor="let title of t('our-story.titles')" [innerHTML]="title" class="title"></h1>
        </div>

        <app-button [buttonText]="t('our-story.button')" href="/our-story" mode="dark" size="big" type="outline"></app-button>
      </div>

      <div class="content-group right">
        <img alt="" src="/assets/home-page-cover.png" />
      </div>
    </div>
  </div>

  <div class="inner-page" id="sales-performance">
    <div class="content card">
      <div class="titles">
        <h2 *ngFor="let title of t('sales-performance.titles')" [innerHTML]="title" class="title"></h2>
      </div>

      <p [innerHTML]="t('sales-performance.subtitle')" class="text-med subtitle"></p>

      <div id="sales-tickers">
        <div *ngFor="let ticker of t('sales-performance.tickers')" class="ticker">
          <div [innerHTML]="ticker.name" class="h6 name"></div>
          <h2 [innerHTML]="ticker.value" class="value"></h2>
        </div>
      </div>
    </div>
  </div>

  <div class="inner-page" id="royal-prestige">
    <div class="content basic-content-with-subtitle img-right">
      <div class="content-group left">
        <h2 *ngFor="let title of t('royal-prestige.titles')" [innerHTML]="title" class="title"></h2>
        <p [innerHTML]="t('royal-prestige.subtitle')" class="text-med subtitle"></p>
        <app-button [buttonText]="t('royal-prestige.button')" href="/royal-prestige" mode="neutral" size="big" type="outline"></app-button>
      </div>

      <div class="content-group right">
        <app-img-with-backdrop
          alt="Food around a pot"
          backdropColor="flour"
          backdropPos="top-right"
          shape="square"
          src="/assets/home-1.jpg"></app-img-with-backdrop>
      </div>
    </div>
  </div>

  <div class="inner-page" id="distribution-channel">
    <div class="content basic-content-with-subtitle">
      <div class="content-group left">
        <app-img-with-backdrop
          alt=""
          backdropColor="flour"
          backdropPos="top-left"
          shape="square"
          src="/assets/home-2.jpg"></app-img-with-backdrop>
      </div>

      <div class="content-group right">
        <h2 *ngFor="let title of t('distribution-channel.titles')" [innerHTML]="title" class="title"></h2>
        <p [innerHTML]="t('distribution-channel.subtitle')" class="text-med subtitle"></p>

        <app-button
          [buttonText]="t('distribution-channel.button')"
          href="/distributors"
          mode="neutral"
          size="big"
          type="outline"></app-button>
      </div>
    </div>
  </div>

  <div class="inner-page" id="our-presence">
    <div class="content card">
      <div class="content-group">
        <h2 *ngFor="let title of t('our-presence.titles')" [innerHTML]="title" class="title"></h2>
        <p [innerHTML]="t('our-presence.subtitle')" class="text-med subtitle"></p>
        <app-button [buttonText]="t('our-presence.button')" href="/our-story" mode="light" size="big" type="outline"></app-button>
      </div>

      <div id="gradient"></div>

      <div class="map-container">
        <app-world-map [locations]="t('our-presence.locations')"></app-world-map>
      </div>
    </div>
  </div>

  <div class="inner-page" id="news" *ngIf="stories">
    <div class="content">
      <div class="title-button">
        <h2 [innerHTML]="t('news.title')" class="title"></h2>
        <app-button [buttonText]="t('news.button')" href="/news" mode="dark" size="big" type="outline"></app-button>
      </div>

      <div id="stories">
        <div *ngFor="let story of stories" class="story">
          <div class="content-group left">
            <img [src]="story.img" alt="" class="wider" />
          </div>

          <div class="content-group right">
            <div [innerHTML]="story.date" class="h6"></div>
            <div [innerHTML]="story.title" class="h4 title"></div>
            <div [innerHTML]="story.teaser" class="text-med subtitle"></div>
            <app-arrow-link href="/article/{{story.slug}}" color="light"></app-arrow-link>
          </div>
        </div>
      </div>

      <app-button
        [buttonText]="t('news.button')"
        [class.mobile-only]="true"
        hidden="hidden"
        href="/news"
        mode="dark"
        size="big"
        type="outline"></app-button>
    </div>
  </div>
</ng-container>
